import { ReactNode } from 'react';
import { message as antdMessage } from 'antd';
import { ArgsProps, NoticeType } from 'antd/lib/message';
import { IconProps } from '@base/icon/interface';
import styles from './index.module.less';
import { IconX } from '@base/icon/IconX';
import { IconHook } from '@base/icon/IconHook';

type IOptions = Omit<ArgsProps, 'content' | 'type'>;

antdMessage.config({
    maxCount: 1,
});

const iconProps = {
    size: '100%',
} as IconProps;

const iconMap = {
    success: <div className={'g-icon g-icon-suc'}><IconHook {...iconProps}/></div>,
    error: <div className={'g-icon g-icon-err'}><IconX {...iconProps}/></div>,
};

const getConfig = (type: NoticeType, content: ReactNode, options?: IOptions): ArgsProps => {
    return {
        ...options,
        className: styles.tip,
        type,
        content,
        duration: 1.5,
        style: {
            marginTop: '20vh'
        },
        icon: iconMap[type] ? iconMap[type] : void 0
    }
};

export const Message = {
    success: (content: ReactNode = 'Successfully!', options?: IOptions) => {
        antdMessage.open(getConfig('success', content, options));
    },
    error: (content: ReactNode = 'Something is wrong.', options?: IOptions) => {
        antdMessage.open(getConfig('error', content, options));
    },
};

export default Message;